import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingActionButtonContext = /*#__PURE__*/createContext({
  isBetaButton: false
});
export const FloatingActionButtonProvider = ({
  isBetaButton = false,
  children
}) => {
  const value = useMemo(() => ({
    isBetaButton
  }), [isBetaButton]);
  return /*#__PURE__*/_jsx(FloatingActionButtonContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `FloatingActionButton` component.
 * Note: The context is only available when the `FloatingActionButton` component is rendered as an ancestor.
 * @returns FloatingActionButtonContext - The context for the `FloatingActionButton` component.
 */
export const useFloatingActionButtonContext = () => {
  return useContext(FloatingActionButtonContext);
};